import {
    AbfLoanExpanded,
    getZcLoanLtv,
    getZcLoanCollateral,
    getZcLoanLiquidationThreshold,
    EstimatedRefinanceInfo
} from "@bridgesplit/abf-react";

import { ActionType } from "./ManagePositionWrapper";

export function useClmmRefinanceInfo(loanExpanded: AbfLoanExpanded) {
    const loanLtv = getZcLoanLtv(loanExpanded) ?? 0;
    const loanCollateralMint = getZcLoanCollateral(loanExpanded)?.metadata?.mint ?? "";
    const loanLiquidationThreshold = getZcLoanLiquidationThreshold(loanExpanded) ?? 0;

    const refinanceInfo: EstimatedRefinanceInfo = {
        ltv: loanLtv,
        liquidationThreshold: loanLiquidationThreshold,
        collateralMint: loanCollateralMint
    };

    return { refinanceInfo };
}

export function getActionType(actionType: ActionType) {
    switch (actionType) {
        case "deposit":
        case "withdraw":
            return 0;
        case "open":
            return 1;
    }
}

export function getActionTypeInitalized(actionType: ActionType, actionTypes: ActionType[] | undefined) {
    if (!actionTypes) return false;
    if (actionTypes.length === 0) return false;
    return actionTypes.includes(actionType);
}
